import { useEffect, useState } from 'react'
import { AdminDashboard } from './components/AdminDashboard'
import { PortfolioSite } from './components/PortfolioSite'
import { loadPortfolio, PortfolioAccessError } from './lib/portfolio'
import type { PortfolioPayload } from './types'

function AccessState({ error }: { error: PortfolioAccessError }) {
  return (
    <main className="state-page">
      <div className="state-mark">{error.code === 'LINK_EXPIRED' ? '00:00' : '•••'}</div>
      <p className="eyebrow">PRIVATE PORTFOLIO</p>
      <h1>{error.message}</h1>
      <p>请联系分享者获取新的访问链接。</p>
    </main>
  )
}

export default function App() {
  const isAdmin = window.location.pathname.startsWith('/admin')
  const [payload, setPayload] = useState<PortfolioPayload | null>(null)
  const [isDemo, setIsDemo] = useState(false)
  const [error, setError] = useState<PortfolioAccessError | null>(null)

  useEffect(() => {
    if (isAdmin) return
    loadPortfolio()
      .then(({ data, demo }) => {
        setPayload(data)
        setIsDemo(demo)
      })
      .catch((reason) =>
        setError(
          reason instanceof PortfolioAccessError
            ? reason
            : new PortfolioAccessError('页面暂时无法加载。', 'UNKNOWN'),
        ),
      )
  }, [isAdmin])

  if (isAdmin) return <AdminDashboard />
  if (error) return <AccessState error={error} />
  if (!payload) return <main className="state-page"><div className="loader" /><p>正在整理作品…</p></main>

  return <PortfolioSite data={payload} isDemo={isDemo} />
}
